(() => {
  const normalize = (value = '') =>
    String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  const configuredTerms = () =>
    String(window.holographicEffectTerms || 'holo, reverse holo, foil')
      .split(',')
      .map(normalize)
      .filter(Boolean);

  const matches = (variantTitle) => {
    const normalizedTitle = normalize(variantTitle);
    return Boolean(normalizedTitle) && configuredTerms().some((term) => normalizedTitle.includes(term));
  };

  const updateProduct = (productInfo, variant) => {
    if (!productInfo) return;

    const activeMedia = productInfo.querySelector('media-gallery li.is-active .product__media');
    productInfo
      .querySelectorAll('media-gallery .product__media.is-holographic')
      .forEach((media) => media.classList.remove('is-holographic'));

    if (variant && matches(variant.title)) activeMedia?.classList.add('is-holographic');
  };

  const getInitialVariant = (productInfo) => {
    const variantJson = productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent;
    if (!variantJson?.trim()) return null;

    try {
      return JSON.parse(variantJson);
    } catch (error) {
      console.warn('No se pudo leer la variante para el efecto holográfico.', error);
      return null;
    }
  };

  const initializeProducts = (root = document) => {
    root.querySelectorAll('product-info').forEach((productInfo) => updateProduct(productInfo, getInitialVariant(productInfo)));
  };

  window.HolographicEffect = { matches, updateProduct };

  document.addEventListener('DOMContentLoaded', () => initializeProducts());
  document.addEventListener('product-info:loaded', ({ target }) => updateProduct(target, getInitialVariant(target)));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${CSS.escape(data.sectionId)}"]`);
      requestAnimationFrame(() => updateProduct(productInfo, data.variant));
    });
  }
})();
